import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Center, Text } from "@chakra-ui/react";
import { AuthContext } from "contexts/AuthContext";
import { KEYS } from "constants/keys";
import { ROUTES } from "constants/routes-path";
import { hasPermission } from "utils/permission";

const RouteGuard = ({ allowedRoles, permissions }) => {
  const { t } = useTranslation();
  const { getUserData } = useContext(AuthContext);
  const location = useLocation();
  const user = getUserData();

  if (!user) {
    let redirectTo = `?${KEYS.redirectTo}=${encodeURI(location.pathname)}`;
    return <Navigate to={ROUTES.login + redirectTo} state={{ from: location }} replace />;
  }

  const allowAccess = allowedRoles ? true : true;

  if (!allowAccess || permissions && !hasPermission({ userPermissions: user?.profilesPermissions, requiredPermissions: permissions })) {
    return (
      <Center bg={'white'}>
        <Text fontSize="md" fontWeight="bold" textColor={'red'}>
          {t("system.messages.errors.access-denied")}
        </Text>
      </Center>
    );
  }

  return <Outlet />;
};

export default RouteGuard;
